import bgMapSrc from '@assets/images/bg-map.jpg';
import { Stack } from 'component-library';
import { FC, PropsWithChildren } from 'react';

import { Footer } from '@/components';
import { useScreenSize } from '@/hooks/useScreenSize';

export const NewProjectLayout: FC<PropsWithChildren> = ({ children }) => {
  const isLargeScreen = useScreenSize() === 'large';

  return (
    <>
      <Stack
        className='bg-map-texture h-full min-h-screen justify-normal bg-cover md:justify-between'
        style={{ backgroundImage: `url(${bgMapSrc})` }}
      >
        {children}
        {isLargeScreen && <Footer variant='white' />}
      </Stack>
    </>
  );
};
